import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import colors from '../styles/colors';

const FooterContainer = styled.footer`
  background: ${colors.neutral.darkGray};
  color: white;
  padding: 3rem 0 1rem;
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
`;

const Content = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  margin-bottom: 2rem;
`;

const Section = styled.div`
  h3 {
    font-size: 1.2rem;
    font-weight: 600;
    margin-bottom: 1rem;
    color: ${colors.primary.green};
  }

  p, a {
    color: #ccc;
    text-decoration: none;
    line-height: 1.6;
    margin-bottom: 0.5rem;
    display: block;
    transition: color 0.3s ease;

    &:hover {
      color: ${colors.primary.green};
    }
  }
`;

const LogoSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 1rem;

  img {
    height: 60px;
    width: auto;
  }
`;


const BottomBar = styled.div`
  border-top: 1px solid #555;
  padding-top: 1rem;
  text-align: center;
  color: #999;
  font-size: 0.9rem;
`;

const Footer = () => {
  const { t } = useTranslation();

  return (
    <FooterContainer>
      <Container>
        <Content>
          <Section>
            <LogoSection>
              <img src="./logo.png" alt="Cuore Brasiliano" />
            </LogoSection>
          </Section>

          <Section>
            <h3>{t('footer.menu')}</h3>
            <a href="#menu">{t('footer.menuItems.appetizers')}</a>
            <a href="#menu">{t('footer.menuItems.firstCourses')}</a>
            <a href="#menu">{t('footer.menuItems.desserts')}</a>
            <a href="#menu">{t('footer.menuItems.beverages')}</a>
          </Section>

          <Section>
            <h3>{t('footer.contacts')}</h3>
            <p>{t('contact.address')}</p>
            <p>{t('contact.phone')}</p>
            <p>{t('contact.landline')}</p>
            <p>{t('contact.email')}</p>
            <p>{t('contact.hoursText')}</p>
          </Section>

          <Section>
            <h3>{t('footer.follow')}</h3>
            <p>{t('footer.followItems.news')}</p>
            <p>{t('footer.followItems.offers')}</p>
            <p>{t('footer.followItems.events')}</p>
          </Section>
        </Content>

        <BottomBar>
          <p>&copy; 2025 Cuore Brasiliano. {t('footer.rights')}</p>
          <p>
            {t('footer.developedBy')} <a href="https://www.convertrex.com.br/" target="_blank" rel="noopener noreferrer" style={{ color: colors.primary.green, textDecoration: 'none' }}>CONVERTREX</a>
          </p>
        </BottomBar>
      </Container>
    </FooterContainer>
  );
};

export default Footer;
